'use client'
import IntegrationsPanel from "../../components/integrations/IntegrationsPanel";

export const IntegrationsPage = () => {
	return (
		<div>
			<IntegrationsPanel />
		</div>
	);
};

